import LinkToDocusaurus from '../LinkToDocusaurus'
import { schedule } from '../../docs-routes'

const LinkToScheduleManagementDoc = () =>
  <LinkToDocusaurus path={schedule}>
    Learn more about Schedule Management
  </LinkToDocusaurus>

export default LinkToScheduleManagementDoc
